import { ExpandedCollapsed } from 'components/contract/interfaces';
import { Context, createContext, ReactNode, useContext, useState } from 'react';

export interface ContractContextType {
    expCol: ExpandedCollapsed;
    setExpCol: (k: string, v: 'expanded' | 'collapsed') => void;
}
const initialState = {
    expCol: new ExpandedCollapsed({ all: 'expanded' }),
    selection: undefined,
};

const states: { [key: string]: Context<ContractContextType | undefined> | undefined } = {};

export const getCommitsPageContext = (context?: ContractContextType) => {
    const key = 'contract';
    if (!states[key] && context) {
        states[key] = createContext<ContractContextType | undefined>(context);
    }
    return states[key] as Context<ContractContextType | undefined>;
};

interface ContractContextProviderProps {
    children: ReactNode | undefined;
}
export const CommitsPageContextProvider = ({ children }: ContractContextProviderProps) => {
    const [expCol, setExpCol_] = useState<ExpandedCollapsed>(initialState.expCol);
    const setExpCol = (k: string, v: 'expanded' | 'collapsed') => {
        if (k === 'all') {
            return setExpCol_(new ExpandedCollapsed({ all: v }));
        }
        return setExpCol_(new ExpandedCollapsed({ ...expCol, [k]: v }));
    };
    const context = { expCol, setExpCol };
    const ActualContext = getCommitsPageContext(context);
    return <ActualContext.Provider value={context}>{children}</ActualContext.Provider>;
};

export function useCommitsPageContext() {
    const context = useContext(getCommitsPageContext());
    if (context === undefined) {
        throw new Error('useCommitsPageContext must be used within a CommitsPageContextProvider');
    }
    return context;
}
